import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import SearchBox from "../../shared/components/SearchBox";
import { services } from "../actions";
import selectors from "../selectors";

class ServicesListFilter extends Component {
  constructor(props) {
    super(props);
    const { filterTerm } = props;
    this.state = { value: filterTerm };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.filterTerm !== state.value) {
      return {
        value: props.filterTerm
      };
    }
    return null;
  }

  handleChange = e => {
    const { setFilterTerm } = this.props;
    const filterTerm = e.target.value.toLowerCase();

    this.setState({ value: e.target.value });
    setFilterTerm(filterTerm);
  };

  resetFilter = () => {
    const { setFilterTerm } = this.props;

    this.setState({ value: "" });
    setFilterTerm("");
  };

  render() {
    const { value } = this.state;
    return (
      <SearchBox
        value={value}
        placeholder="Filter services"
        onChange={e => this.handleChange(e)}
        onReset={() => this.resetFilter()}
        style={{ marginBottom: ".5rem" }}
      />
    );
  }
}

ServicesListFilter.propTypes = {
  setFilterTerm: PropTypes.func.isRequired,
  filterTerm: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  filterTerm: selectors.services.getFilterTerm(state)
});

const mapDispatchToProps = {
  setFilterTerm: services.setFilterTerm
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicesListFilter);
